import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { GitHub } from '@mui/icons-material';
import { authAPI } from '../services/authAPI';

const LoginPage: React.FC = () => {
  const handleGitHubLogin = () => {
    authAPI.githubLogin();
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Engineer Login
        </Typography>
        
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          Sign in with your GitHub account to access the engineer portal
        </Typography>
        
        <Button
          variant="contained"
          size="large"
          startIcon={<GitHub />}
          onClick={handleGitHubLogin}
          sx={{
            backgroundColor: '#24292e',
            '&:hover': {
              backgroundColor: '#1a1e22',
            },
          }}
        >
          Sign in with GitHub
        </Button>
        
        <Box sx={{ mt: 4, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="caption" color="textSecondary">
            Only authorized engineers with GitHub accounts linked to the organization can access this portal.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;